import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";

export const fetchCandidatePartialData = createAsyncThunk('getPartialCandidateData/fetchPartialCandidateData',
  async ({page,SB,order,candidateStatus, size}, { rejectWithValue }) => {
    try {
      const url = `${api.getPartialCandidateData}?type=0&page=${(page-1)}&size=${size}&sortBy=${SB}&direction=${order}&filterStatus=${candidateStatus}`
      const response = await axiosPrivate.get(url);
      return response.data.data;
    } catch(error) {
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  })

const getPartialCandidateData = createSlice({
  name: 'Candidates',
  initialState: {
    Candidates: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(fetchCandidatePartialData.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(fetchCandidatePartialData.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.Candidates = action.payload;
        })
      .addCase(fetchCandidatePartialData.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getPartialCandidateData.reducer;